<template>
  <div class="home">
    <header>
      <div class="header-box">
        <div class="logo" @click="goHome">
          <img
            src="https://www.fotile.com/onlineh5/windcubepc/images/cge_69666a45753fa96eaec673fa1551dc82.png?_v_=83bd26709b047766"
            alt=""
          />
        </div>
        <div class="back-home" @click="goHome">返回官网首页</div>
      </div>
    </header>
    <!-- banner -->
    <section>
      <div class="top-banner">
        <swiper
          :options="swiperOption"
          ref="bannerSwiper"
          class="banner-swiper"
        >
          <!-- :style="{ height: vboxHeight + 'px' }" -->
          <swiper-slide
            class="banner-swiper-items"
            v-for="item in bannerList"
            :key="item.src"
            style="height: auto"
          >
            <img
              v-if="item.type === '1'"
              class="sitems-img"
              :src="item.src"
              alt=""
              ref="bimg"
            />
            <div
              v-else-if="item.type === '2'"
              class="ad-video"
              :style="{ backgroundImage: 'url(' + item.backgroundImage + ')' }"
            ></div>
            <!-- <video
              class="ad-video"
              v-else-if="item.type === '2'"
              :src="item.src"
              :style="{backgroundImage:'url('+item.backgroundImage+')'}"
            ></video> -->
            <div
              class="ad-video-pbox"
              v-if="item.type === '2'"
              @click="goVideo(item)"
            >
              <img class="ad-video-play" src="../assets/play@2x.png" alt="" />
            </div>
          </swiper-slide>
          <div
            class="swiper-pagination bswiper-pagination"
            slot="pagination"
          ></div>
        </swiper>
      </div>
    </section>
    <!-- con 1 -->
    <section>
      <div class="home-con-1">
        <img src="../assets/new/bg-02.png" alt="" class="bg-img" />
      </div>
      <div class="home-con-1">
        <img src="../assets/new/bg-03.png" alt="" class="bg-img" />
      </div>
      <div class="home-con-1">
        <img src="../assets/new/bg-04.png" alt="" class="bg-img" />
      </div>
      <div class="home-con-1">
        <img src="../assets/new/bg-05.png" alt="" class="bg-img" />
      </div>
    </section>
    <!-- con 2 -->
    <section>
      <div class="home-con-2">
        <img src="../assets/new/title1@2x.png" alt="" class="title1" />
        <img src="../assets/new/con1@2x.png" alt="" class="con-img-1" />
        <img src="../assets/new/title2@2x.png" alt="" class="title2" />
        <img src="../assets/new/con2@2x.png" alt="" class="con-img-2" />
      </div>
    </section>
    <!-- btn -->
    <section>
      <div class="btn-box">
        <!-- <div class="btn-1">
          <img src="../assets/new/btn1@2x.png" alt="" />
        </div> -->
        <div class="btn-2" @click="downImg">
          <img src="../assets/new/btn2@2x.png" alt="" />
        </div>
      </div>
    </section>
    <!-- 安装方法 -->
    <section>
      <div class="items-box">
        <img class="item1" src="../assets/new/item1@2x.png" alt="" />
        <img class="item2" src="../assets/new/item2@2x.png" alt="" />
      </div>
    </section>
    <!-- btn2 -->
    <div class="items2-box">
      <img
        class="items-btn3"
        src="../assets/new/btn3@2x.png"
        alt=""
        @click="productAskClick"
      />
    </div>

    <!-- footer -->
    <section>
      <div class="footer">
        <div class="bgcolor">
          <div class="w1170">
            <div class="info">
              <ul>
                <li style="width: 165px">
                  <h6 onclick="setFs('all')">所有产品</h6>

                  <a
                    href="https://www.fotile.com/chanpin/486/"
                    target="_blank"
                    onclick="setFs('product','嵌入式灶具')"
                    >嵌入式灶具</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/297/"
                    target="_blank"
                    onclick="setFs('product','吸油烟机')"
                    >吸油烟机</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/548/"
                    target="_blank"
                    onclick="setFs('product','嵌入式消毒柜')"
                    >嵌入式消毒柜</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/554/"
                    target="_blank"
                    onclick="setFs('product','嵌入式蒸箱')"
                    >嵌入式蒸箱</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/555/"
                    target="_blank"
                    onclick="setFs('product','嵌入式烤箱')"
                    >嵌入式烤箱</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/556/"
                    target="_blank"
                    onclick="setFs('product','嵌入式微波炉')"
                    >嵌入式微波炉</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/559/"
                    target="_blank"
                    onclick="setFs('product','水槽洗碗机')"
                    >水槽洗碗机</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/560/"
                    target="_blank"
                    onclick="setFs('product','燃气热水器')"
                    >燃气热水器</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/563/"
                    target="_blank"
                    onclick="setFs('product','净水机')"
                    >净水机</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/565/"
                    target="_blank"
                    onclick="setFs('product','集成烹饪中心')"
                    >集成烹饪中心</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/568/"
                    target="_blank"
                    onclick="setFs('product','烹饪机')"
                    >烹饪机</a
                  >
                  <a
                    href="https://www.fotile.com/chanpin/597/"
                    target="_blank"
                    onclick="setFs('product','智联油烟净化系统')"
                    >智联油烟净化系统</a
                  >
                  <a href="https://www.fotile.com/chanpin/1372/" target="_blank"
                    >新风空净</a
                  >
                  <a
                    href="https://www.fotile.com/subject/fiks.html"
                    target="_blank"
                    onclick="setFs('FIKS')"
                    >FIKS智能系统</a
                  >
                </li>
                <li style="width: 147px">
                  <h6 onclick="setFs('buy')">购买</h6>
                  <a
                    href="https://www.fotile.com/service/city/queryCity.html?utm_source=fotile-guanwang-shouye-dibu-zhuanmaid0303"
                    style="color: #aa001a"
                    target="_blank"
                    onclick="setFs('shop')"
                    >专卖店查询</a
                  >
                  <a
                    class="utm-source"
                    rel="nofollow"
                    href="https://www.efotile.com/?utm_source=fotile-guanwang-shouye-weibu-shangcheng0303"
                    target="_blank"
                    onclick="setFs('fotile')"
                    >方太商城</a
                  >
                  <a
                    rel="nofollow"
                    href="https://mall.jd.com/index-1000000907.html?cu=true&utm_source=kong&utm_medium=tuiguang&utm_campaign=t_1001006693_1089_5742_null"
                    target="_blank"
                    onclick="setFs('jingdong')"
                    >方太京东旗舰店</a
                  >
                  <a
                    rel="nofollow"
                    href="https://equity.tmall.com/tm?agentId=976428&_bind=true&bc_fl_src=tmall_market_llb_1_1141052&llbPlatform=_pube&llbOsd=1"
                    target="_blank"
                    onclick="setFs('tianmao')"
                    >方太天猫旗舰店</a
                  >
                </li>
                <li style="width: 166px">
                  <h6>服务与帮助</h6>
                  <a href="/service.html" target="_blank">服务首页</a>
                  <a
                    href="https://www.fotile.com/service/fuwuzhengce.html"
                    target="_blank"
                    onclick="setFs('serve')"
                    >服务政策</a
                  >
                  <a
                    href="https://www.fotile.com/service/fuwushoufei.html"
                    target="_blank"
                    onclick="setFs('shoufei')"
                    >服务收费标准</a
                  >
                  <a
                    href="https://www.fotile.com/help.html"
                    target="_blank"
                    onclick="setFss('help')"
                    >帮助中心</a
                  >
                  <a
                    href="https://www.fotile.com/service/city/queryCity.html"
                    target="_blank"
                    onclick="setFs('shop')"
                    >售后电话查询</a
                  >
                </li>
                <li style="width: 170px">
                  <h6>方太幸福家</h6>
                  <a
                    href="https://www.fotile.com/xingfu/"
                    target="_blank"
                    style="color: #aa001a"
                    >方太幸福家首页</a
                  >
                  <a
                    href="https://www.fotile.com/xingfu/cooking.html"
                    target="_blank"
                    >美食烹饪</a
                  >
                  <a
                    href="https://www.fotile.com/xingfu/renovation.html"
                    target="_blank"
                    >居家装修</a
                  >
                  <a
                    href="https://www.fotile.com/xingfu/health.html"
                    target="_blank"
                    >健康养生</a
                  >
                  <a
                    href="https://www.fotile.com/xingfu/grow.html"
                    target="_blank"
                    >幸福成长</a
                  >
                  <a
                    href="https://www.fotile.com/xingfu/8656.html"
                    target="_blank"
                    >APP下载</a
                  >
                </li>
                <li style="width: 149px">
                  <h6>关于方太</h6>
                  <a
                    href="https://www.fotile.com/brand/about.html"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('about')"
                    >方太简介</a
                  >
                  <a
                    href="https://www.fotile.com/brand/history.html"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('history')"
                    >发展历程</a
                  >
                  <a
                    href="https://www.fotile.com/brand/power.html"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('power')"
                    >方太实力</a
                  >
                  <a
                    href="https://www.fotile.com/brand/obligation.html"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('obligation')"
                    >社会责任</a
                  >
                  <a
                    href="https://www.fotile.com/news/567.html"
                    rel="nofollow"
                    target="_blank"
                    >方太文化研究院</a
                  >
                </li>
                <li style="width: 153px">
                  <h6>媒体中心</h6>
                  <a
                    href="https://www.fotile.com/news"
                    target="_blank"
                    onclick="setFs('news')"
                    >方太资讯</a
                  >
                  <a
                    href="https://www.fotile.com/video.html"
                    target="_blank"
                    onclick="setFs('video')"
                    >方太影像</a
                  >
                </li>
                <li style="width: 149px">
                  <h6 onclick="setFs('co')">寻求合作</h6>
                  <a
                    href="https://www.fotile.com/brand/contact.html"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('contact')"
                    >联系我们</a
                  >
                  <a
                    href="https://www.fotile.com/programme.html"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('programme')"
                    >工程合作</a
                  >
                  <a
                    href="https://www.fotile.com/brand/dealer.html"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('dealer')"
                    >经销加盟</a
                  >
                </li>
                <li style="width: 66px">
                  <h6 onclick="setFs('join')" style="color: #aa001a">
                    加入方太
                  </h6>
                  <a
                    href="http://job.fotile.com/social"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('social')"
                    >社会招聘</a
                  >
                  <a
                    href="http://job.fotile.com/campus"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('campus')"
                    >校园招聘</a
                  >
                  <a
                    href="http://job.fotile.com/cjobs"
                    rel="nofollow"
                    target="_blank"
                    onclick="setFs('cjobs')"
                    >实习生招聘</a
                  >
                </li>
              </ul>
            </div>

            <div class="tipTxt2">
              网站中涉及的数据、统计资料或调查结果（如有）等属于引证内容的，除特别标注外，其余均来自方太。<br />
              *高效滤除重金属：根据浙（省）疾控检字第201901180号检测报告显示，可有效滤除砷、镉、铬（六价）、铅等重金属。<br />
              *保留有益矿物质：根据中国家用电器检测所WCjs-19-40161号检测报告显示，可保留钙、钾、镁、钠，等矿物质。<br />
              *不跑烟：在方太实验室规定条件下测试，肉眼未见明显的油烟逃逸。<br />
              *龙头一开，热水即来：需提前开启循环功能，由于循环水路到出水点具体安装可能因龙头、花洒或支路产生一小截冷水。<br />
              *还能去果蔬农残：指能有效去除果蔬表面的氧化乐果、乐果等农药残留。<br />
              *同层同温：在方太实验室规定条件下测试，热风烘焙模式下180℃条件下，同层温差小于7℃。<br />
              *双倍：加热盘与水的接触面积约是上一代产品的2倍。<br />
              *110℃：在方太试验室规定条件下，过温蒸模式下测得。<br />
              *根据广东省微生物分析检测中心等机构的检测数据，方太水槽洗碗机对乙酰甲胺磷、氧化乐果、乐果等农药的去除率均达到了90%以上。<br />
              *根据广东省微生物分析检测中心等机构的检测数据，方太水槽洗碗机对大肠杆菌和金黄色葡萄球菌的去除率均达到99.99%。<br />
              *广东微生物分析检测中心报告编号2016FM2255-1<br />
              *中式蒸箱创新者：中国发明专利号ZL201210327073.2<br />
            </div>

            <div class="foot_copy">
              <div class="f_logo"></div>
              <div class="f_copyright">
                ©1996-{{ year }}
                <span class="year"></span>
                方太集团 |
                <a
                  style="color: #888896"
                  href="http://beian.miit.gov.cn"
                  target="_blank"
                  >浙ICP备05083555号-1</a
                >
                |
                <a
                  style="color: #888896"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33029202000036"
                  target="_blank"
                  >浙公网安备 33029202000036号</a
                >
              </div>
              <div class="f_links">
                <a
                  href="https://www.fotile.com//provisions.html"
                  target="_blank"
                  >法律声明</a
                ><u>|</u>
                <a href="https://www.fotile.com//help/link.html" target="_blank"
                  >友情链接</a
                ><u>|</u>
                <a href="http://fotileglobal.com/" target="_blank">海外官网</a>
              </div>
              <div class="f_other">
                <a
                  href="http://idinfo.zjamr.zj.gov.cn/bscx.do?method=lzxx&id=3302183302180000000976"
                  class="logo3"
                  target="_blank"
                ></a>
                <a href="javascript:;" class="logo4"></a>
                <a href="javascript:;" class="wx"><i></i></a>
                <a
                  href="http://weibo.com/u/1768742990?topnav=1&wvr=6&topsug=1"
                  class="sina"
                  target="_blank"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--视频播放 弹窗 -->
    <section>
      <el-dialog
        title=""
        :visible.sync="videoFlag"
        :show-close="false"
        :close-on-click-modal="false"
        width="100%"
        custom-class="video-dialog"
        :modal-append-to-body="false"
        :append-to-body="true"
      >
        <div class="wrapper-video" @click.stop>
          <!--
          :style="{height:vboxHeight+'px'}" -->
          <img
            src="../assets/video_close@2x.png"
            alt=""
            class="wrapper-video-close"
            @click="closeVideo"
          />
          <!-- video_close@2x.png -->
          <!-- <vue-aliplayer-v2
            :source="showVurl"
            ref="alipaly"
            :options="options"
            class="wrap"
            @ready="handleReady"
            @requestFullScreen="handleRequestFullScreen"
          /> -->
        </div>
      </el-dialog>
    </section>
    <div class="prism-player" id="J_prismPlayer"></div>
    <vue-aliplayer-v2
      :source="showVurl"
      ref="alipaly"
      :options="options"
      class="wrap"
      @cancelFullScreen="handleCancelFullScreen"
      @requestFullScreen="handleRequestFullScreen"
    />
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import installIMG from "@/assets/new/install-img.png";
import $ from "jquery";
import banner1 from "@/assets/new/bg-01.png";
import banner2 from "@/assets/new/banner2.png";

export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    // adesc,
  },
  data() {
    return {
      options: {
        // format: 'm3u8'  //切换为直播流的时候必填
        x5_fullscreen: true,
        rePlay: false, //自动循环播放。
        preload: false,
        autoplay: false,
        height: "100%",
        width: "100%",
        // videoWidth:boxWidth,
        videoHeight: "auto",
        useH5Prism: false,
        isLive: false, //是不是直播
        controlBarVisibility: "always",
        cover: "",
        // cover:"https://hsimage.fotile.com/4fbf8b61-6e0a-4494-932e-62e3576cd030.png",
        function(player) {
          //先静音然后播放
          player.mute();
          player.play();
        },
        skinLayout: [
          { name: "bigPlayButton", align: "blabs", x: 30, y: 80 },
          {
            name: "H5Loading",
            align: "cc",
          },
          { name: "errorDisplay", align: "tlabs", x: 0, y: 0 },
          { name: "infoDisplay" },
          { name: "tooltip", align: "blabs", x: 0, y: 56 },
          { name: "thumbnail" },
          {
            name: "controlBar",
            align: "blabs",
            x: 0,
            y: 0,
            children: [
              // {name: "progress", align: "blabs", x: 20, y: 44},
              { name: "playButton", align: "tl", x: 80, y: 10 },
              { name: "fullScreenButton", align: "tr", x: 10, y: 12 },
              // {name: "timeDisplay", align: "tl", x: 10, y: 7},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name: "volume", align: "tr", x: 5, y: 10}
            ],
          },
        ],
      },
      video_source:
        "https://hsvod.fotile.com/b7560b31db0545e5a3fa37b1f503d3ca/2762eb43d75845959783c66d6e9d2cb2-a65fa239ccf650813cd41b0f6d7cbb97-sd.m3u8",
      vboxHeight: 740,
      bannerTab: [], //banner tab
      seTab: 0,
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      bannerList: [
        {
          type: "1",
          src: banner1,
        },
        {
          type: "2",
          backgroundImage: banner2,
          src:
            "https://hsvod.fotile.com/09b806adae334c50898748479fc4f069/550af7e9ec0242278772132d15cace96-b33f4956708198d251fe3bbeeedfb903-sd.m3u8",
        },
      ],
      scrollIndex: null, //已开始index
      lineWidth: "", //时间轴宽度
      // liHeight: 300, //li-height
      isWait: false, //敬请期待flag
      seeItem: false, //展示保存图
      current: 0,

      yyDialog: false,
      isWechat: false,
      menuInfo: [], //footer-menu

      province_array: [], //省arr
      city_array: [], //市arr
      area_array: [], //区arr
      azindex: 10,
      openFlag: false,
      openFlag2: false,
      openFlag3: false,
      openFlag4: false,
      openFlag5: false,
      cindex: 0, //时间轴-items-index
      timeOutEvent: 0,
      longClick: 0,
      year: "",
      ntype: "1", //2为门店跳转进入
      utm_source: "", //来源
      videoFlag: false, //video播放
      showVurl: "", //video播放url
      coverUrl: "", //封面图
    };
  },
  created() {
    document.title = "方太水槽洗碗机";
  },

  mounted() {},

  methods: {
    productAskClick() {
      $.getScript(
        "//dl.ntalker.com/js/xn6/ntkfstat.js?siteid=kf_9729",
        function () {
          NTKF.im_openInPageChat("kf_9729_1482141141679");
        }
      );
    },
    downImg() {
      let link = document.createElement("a");
      link.download = "方太水槽洗碗机E6高清安装示意图";
      link.href = installIMG;
      link.click();
      link.remove();
    },
    goHome() {
      window.location.href = "https://www.fotile.com/";
    },
    handleRequestFullScreen() {},
    handleCancelFullScreen(e) {
      console.log(`退出`, e);
      this.$refs.alipaly.pause();
    },
    closeVideo() {
      // console.log("关闭", this.$refs.alipaly);
      this.$refs.alipaly.pause();
      // this.$refs.alipaly.dispose();
      //
      this.videoFlag = false; // 暂停播放
    },
    goVideo(item) {
      // this.videoFlag = true;
      console.log("播放", item);
      this.showVurl = item.src;
      this.options.cover = item.backgroundImage;
      this.$refs.alipaly.replay();
      this.$refs.alipaly.requestFullScreen();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/home.scss";
</style>
<style lang="scss">
@import "~@/assets/scss/common.scss";
</style>
<style>
.ntalk-window-containter {
  right: 0 !important;
  bottom: 0 !important;
  left: auto !important;
  top: auto !important;
}
@import "~@/assets/scss/footer.css";
</style>
